module.exports = __webpack_public_path__ + "static/img/topLeft.9985449d.png";